import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ModalService } from '../../../../../../lib-os-components/src/public-api';
import { environment } from '../../../../environments/environment';
import { FsService } from '../fs.service';
import { DialogNameComponent } from './dialog-name/dialog-name.component';
@Component({
    selector: 'blog-fs-add-page',
    templateUrl: './fs-add-page.component.html',
    styleUrls: ['./fs-add-page.component.scss'],
    imports: [CommonModule],
})
export class FsAddPageComponent {
    @Input() public isArticle = true;
    @Input() public label?: string;

    public env = environment;

    public constructor(
        private modalService: ModalService,
        private fsService: FsService
    ) {}

    public addpageClicked(): void {
        this.openDialog();
    }

    private addAuthor(name: string): void {
        this.fsService.addAuthor(name);
    }

    private addArticle(name: string): void {
        this.fsService.addArticle(name);
    }

    private openDialog(): void {
        const dialogRef = this.modalService.openDialog({
            component: DialogNameComponent,
            configuration: {
                headline: this.label ?? '',
                label: '',
                open: true,
                size: 's',
                status: '',
                closeButton: true,
            },
            data: { isArticle: this.isArticle },
        });

        dialogRef.afterClosed$.subscribe((result) => {
            if (result) {
                if (this.isArticle) {
                    this.addArticle(result.data);
                } else {
                    this.addAuthor(result.data);
                }
            }
        });
    }
}
